import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-highlight.reducer';

export const ActivityHighlightDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityHighlightEntity = useAppSelector(state => state.activityHighlight.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityHighlightDetailsHeading">
          <Translate contentKey="activitiesApp.activityHighlight.detail.title">ActivityHighlight</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityHighlightEntity.id}</dd>
          <dt>
            <span id="highlightNote">
              <Translate contentKey="activitiesApp.activityHighlight.highlightNote">Highlight Note</Translate>
            </span>
          </dt>
          <dd>{activityHighlightEntity.highlightNote}</dd>
          <dt>
            <Translate contentKey="activitiesApp.activityHighlight.activity">Activity</Translate>
          </dt>
          <dd>{activityHighlightEntity.activity ? activityHighlightEntity.activity.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/activity-highlight" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity-highlight/${activityHighlightEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityHighlightDetail;
